var map = {
	"./Population.svg": 2672,
	"./analysis.svg": 769,
	"./blast copy.svg": 8762,
	"./blast.svg": 2738,
	"./browse.svg": 6241,
	"./chazhao.svg": 8002,
	"./contact.svg": 3612,
	"./download.svg": 1356,
	"./fst.svg": 5215,
	"./genome.svg": 7990,
	"./genome1.svg": 561,
	"./go.svg": 2463,
	"./gwas.svg": 2455,
	"./gwas1.svg": 8183,
	"./home.svg": 1269,
	"./jiyinxin.svg": 1408,
	"./kegg.svg": 5308,
	"./language.svg": 9780,
	"./lianjie.svg": 604,
	"./msa.svg": 6220,
	"./pathway.svg": 6919,
	"./peo.svg": 4726,
	"./pi.svg": 882,
	"./qtl.svg": 7513,
	"./search.svg": 7640,
	"./search1.svg": 3644,
	"./sequence.svg": 2771,
	"./sequence1.svg": 105,
	"./structure.svg": 1056,
	"./te.svg": 1683,
	"./tools.svg": 8387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1620;